<template>
    <div v-if="startVipCount || timeStr != '' " class="com-vip-newyear-button-box" @click="clickVipButton">
        <div class="com-vip-ny-btn-text">{{timeStr}}</div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils';
export default {
    name: 'VipNyButton',
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        vipCountTime() {
            return this.$store.state.reminder.vipCountTime
        },
        startVipCount() {
            return this.$store.state.reminder.startVipCount
        },
        vipIsToday() {
            return this.$store.state.reminder.vipIsToday
        }
    },
    props: {
        frompage: {
            type: String,
            default() { return '' }
        }
    },
    data() {
        return {
            timeStr: '',
            timeFunc: undefined
        }
    },
    mounted() {
        this.startAni();
        this.$bus.on('startVipBtnAni', this.startAni);
    },
    destroyed() {
        this.clearAni();
        this.$bus.off('startVipBtnAni', this.startAni);
    },
    methods: {
        clickVipButton() {
            this.$store.state.user.curVipPayType = this.userData && this.userData.donate == 1 ? 3 : 4;
            this.$store.state.user.showMyVip = true;
            var me = this;
            setTimeout(() => {
                me.$bus.emit('initMyVipPage');
            }, 20);
        },
        startAni() {
            // console.error('startAni', this.vipCountTime)
            var me = this, 
                lsTime = localStorage.getItem('h5_vip_count_time'),
                startTime = 0;
            if(me.timeFunc) { clearTimeout(me.timeFunc) };
            if(this.startVipCount) {
                startTime = this.vipCountTime != 0 ? this.vipCountTime : startTime;
            }else {
                startTime = lsTime && parseInt(lsTime) != 0 && me.vipIsToday ? parseInt(lsTime) : startTime;
            }
            this.$store.state.reminder.startVipCount = false;
            function count() {
                me.timeStr = UTILS.getTimeStrBySecond(startTime);
                // console.error('count-----', me.timeStr)
                if(startTime == 0) {
                    me.timeStr = '';
                    clearTimeout(me.timeFunc);
                }else {
                    startTime--;
                    window.localStorage.setItem('h5_vip_count_time', startTime);
                    me.timeFunc = setTimeout(() => {
                        count();
                    }, 1000);
                }
            }
            if(startTime == 0) { return; }
            count();
        },
        clearAni() {
            console.error('clearAni')
            clearTimeout(this.timeFunc);
        }
    }
}
</script>